import {mountSectorWorld} from "./crystal-signal-world.js?v=20260728-crystal-1";

document.documentElement.classList.remove("no-js");

const clamp = (value, min = 0, max = 1) => Math.max(min, Math.min(max, value));
const smooth = (value) => {
  const v = clamp(value);
  return v * v * (3 - 2 * v);
};
const section = document.querySelector("[data-sector-engine]");
const sticky = section?.querySelector(".engine-sticky");
const worldElement = document.querySelector("[data-engine-world]");
const acts = [...document.querySelectorAll("[data-engine-act]")];
const routeItems = [...document.querySelectorAll("[data-route-index]")];
const progressBar = document.querySelector("[data-engine-progress]");
const percent = document.querySelector("[data-engine-percent]");
const coordinate = document.querySelector("[data-engine-coordinate]");
const header = document.querySelector("[data-header]");
const menu = document.querySelector(".menu-toggle");
const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
const loader = document.querySelector("[data-signal-loader]");
const loaderState = document.querySelector("[data-loader-state]");
const loaderPercent = document.querySelector("[data-loader-percent]");
const loaderRail = document.querySelector("[data-loader-rail]");
const supplyImages = [...document.querySelectorAll("[data-supply-src]")];
let supplyPrepared = false;

let world = {setProgress() {}, setDivision() {}};
const worldInitialized = new Promise(resolve => {
  requestAnimationFrame(() => requestAnimationFrame(() => {
    try {
      world = mountSectorWorld(worldElement);
    } catch (error) {
      worldElement?.classList.add("is-static");
      console.warn("RiZe Sector entered static rendering mode.", error);
    }
    resolve(world);
  }));
});

function setLoaderProgress(value, state) {
  const progress = clamp(value);
  loader?.style.setProperty("--loader-progress", progress.toFixed(4));
  if (loaderPercent) loaderPercent.textContent = String(Math.round(progress * 100)).padStart(3, "0");
  if (loaderRail) loaderRail.style.transform = `scaleX(${progress})`;
  if (state && loaderState) loaderState.textContent = state;
}

async function resolveLoader() {
  if (!loader) return;
  document.documentElement.classList.add("is-loading");
  setLoaderProgress(.08, "INITIALIZING SIGNAL");
  const fontReady = document.fonts?.ready ?? Promise.resolve();
  const markReady = new Promise(resolve => {
    const image = new Image();
    image.onload = image.onerror = resolve;
    image.src = "rize.svg";
  });
  await Promise.all([fontReady, markReady]);
  setLoaderProgress(.62, "BUILDING SECTOR");
  const initializedWorld = await worldInitialized;
  await (initializedWorld.ready ?? Promise.resolve());
  initializedWorld.setDivision?.(Math.max(0, activeDivision));
  lastEngineProgress = -1;
  setLoaderProgress(1, "SIGNAL READY");
  requestAnimationFrame(() => requestAnimationFrame(() => {
    loader.classList.add("is-complete");
    document.documentElement.classList.remove("is-loading");
    setTimeout(() => loader.remove(), 900);
  }));
}
resolveLoader();

const actRanges = acts.map(act => ({
  element: act,
  start: Number(act.dataset.start),
  end: Number(act.dataset.end),
}));
const actCenters = actRanges.map(range => (range.start + range.end) / 2);

const divisionData = {
  leaders: {
    index: "01 / 06", title: "LEADERS", status: "09 ACTIVE",
    copy: "Leaders work to make sure the Sector runs smoothly.",
    members: ["Cam", "DNY", "Sicro", "Smolly", "Zuurg", "Ekul", "Knighty", "Natth", "Khy"],
  },
  players: {
    index: "02 / 06", title: "PLAYERS", status: "03 ACTIVE",
    copy: "Both trickshotters and snipers hit high quality clips on Call of Duty for our premier videos.",
    members: ["zFrezr", "Revin", "Strln"],
  },
  editors: {
    index: "03 / 06", title: "EDITORS", status: "02 ACTIVE",
    copy: "Editors make RiZe come to life through creative ideas and video execution.",
    members: ["Rapidz", "Jappe"],
  },
  designers: {
    index: "04 / 06", title: "DESIGNERS", status: "04 ACTIVE",
    copy: "Create Sector is responsible for our apparel, our aesthetic, and the world in which RiZe lives in.",
    members: ["Ekul", "Cam", "Trash", "Zio"],
  },
  creators: {
    index: "05 / 06", title: "CONTENT CREATORS", status: "01 ACTIVE",
    copy: "The backbone of the brand, Content Creators help establish strong communities and establish the name RiZe in various fields of entertainment.",
    members: ["Zuurg"],
  },
  ai: {
    index: "06 / 06", title: "AI DIVISION", status: "COMING SOON",
    copy: "Cutting edge, this division aims to leverage modern tools to give the Sector the ultimate advantage over other gaming organizations.",
    members: ["COMING SOON"],
  },
};
const divisionTabs = [...document.querySelectorAll("[data-division]")];
const divisionPanel = document.querySelector("[data-division-panel]");
let activeDivision = -1;
let divisionLockedUntil = 0;

function renderDivision(index, source = "scroll") {
  const normalized = (index + divisionTabs.length) % divisionTabs.length;
  if (normalized === activeDivision) return;
  activeDivision = normalized;
  const tab = divisionTabs[normalized];
  const data = divisionData[tab.dataset.division];
  divisionTabs.forEach((item, itemIndex) => {
    const active = itemIndex === normalized;
    item.classList.toggle("is-active", active);
    item.setAttribute("aria-selected", String(active));
    item.tabIndex = active ? 0 : -1;
  });
  divisionPanel.setAttribute("aria-labelledby", tab.id);
  divisionPanel.dataset.ghost = String(normalized + 1).padStart(2, "0");
  divisionPanel.querySelector("[data-division-index]").textContent = data.index;
  divisionPanel.querySelector("[data-division-status]").textContent = data.status;
  divisionPanel.querySelector("[data-division-title]").textContent = data.title;
  divisionPanel.querySelector("[data-division-copy]").textContent = data.copy;
  const list = divisionPanel.querySelector("[data-division-members]");
  list.setAttribute("aria-label", data.title);
  list.replaceChildren(...data.members.map(name => {
    const item = document.createElement("li");
    item.textContent = name;
    return item;
  }));
  world.setDivision(normalized);
  if (source === "pointer") divisionLockedUntil = performance.now() + 1600;
}

function sectionMetrics() {
  const rect = section.getBoundingClientRect();
  const run = Math.max(1, section.offsetHeight - innerHeight);
  const travelled = clamp(-rect.top, 0, run);
  return {progress: travelled / run, run, top: scrollY + rect.top};
}

function scrollToProgress(progress, behavior = reduced ? "auto" : "smooth") {
  const {run, top} = sectionMetrics();
  scrollTo({top: top + clamp(progress) * run, behavior});
}

function prepareSupplyImages() {
  if (supplyPrepared) return;
  supplyPrepared = true;
  supplyImages.forEach(image => {
    const source = image.dataset.supplySrc;
    const preload = new Image();
    preload.decoding = "async";
    preload.src = source;
    const commit = () => {
      image.src = source;
      delete image.dataset.supplySrc;
    };
    if (preload.decode) preload.decode().then(commit, commit);
    else preload.onload = commit;
  });
}

divisionTabs.forEach((tab, index) => {
  tab.addEventListener("click", () => {
    renderDivision(index, "pointer");
    const divisionStart = .422;
    const divisionEnd = .586;
    scrollToProgress(divisionStart + index / Math.max(1, divisionTabs.length - 1) * (divisionEnd - divisionStart));
  });
  tab.addEventListener("keydown", event => {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
    event.preventDefault();
    const next = event.key === "Home" ? 0 :
      event.key === "End" ? divisionTabs.length - 1 :
      (index + (event.key === "ArrowRight" ? 1 : -1) + divisionTabs.length) % divisionTabs.length;
    divisionTabs[next].focus();
    renderDivision(next, "pointer");
  });
});
renderDivision(0);

function activeAct(progress) {
  let nearest = 0;
  let distance = Infinity;
  actCenters.forEach((center, index) => {
    const currentDistance = Math.abs(progress - center);
    if (currentDistance < distance) {
      nearest = index;
      distance = currentDistance;
    }
  });
  return nearest;
}

function actOpacity(progress, start, end, index) {
  const range = end - start;
  const edge = Math.min(.035, range * .3);
  const incoming = index === 0 ? 1 : smooth((progress - start) / edge);
  const outgoing = index === actRanges.length - 1 ? 1 : 1 - smooth((progress - (end - edge)) / edge);
  return clamp(incoming * outgoing);
}

let lastEngineProgress = -1;
function update() {
  if (!section || reduced) return;
  const {progress} = sectionMetrics();
  if (Math.abs(progress - lastEngineProgress) < .00001) return;
  lastEngineProgress = progress;
  const activeIndex = activeAct(progress);
  const inversion = smooth((progress - .568) / .018) * (1 - smooth((progress - .716) / .018));
  sticky.style.setProperty("--inversion", inversion.toFixed(4));
  sticky.classList.toggle("is-inverted", inversion > .52);
  world.setProgress(progress);
  if (progress > .32) prepareSupplyImages();

  acts.forEach((act, index) => {
    const range = actRanges[index];
    const opacity = index === 4 ? inversion : actOpacity(progress, range.start, range.end, index);
    const active = index === activeIndex && opacity > .08;
    act.style.setProperty("--act-opacity", opacity.toFixed(4));
    act.style.setProperty("--act-shift", `${(1 - opacity) * (index % 2 ? 22 : -18)}px`);
    act.classList.toggle("is-active", active);
    act.setAttribute("aria-hidden", String(!active));
    act.querySelectorAll("a,button,[tabindex]").forEach(control => {
      if (!active) {
        if (!control.hasAttribute("data-natural-tabindex")) {
          control.dataset.naturalTabindex = control.getAttribute("tabindex") ?? "";
        }
        control.tabIndex = -1;
      } else if (control.dataset.naturalTabindex !== undefined) {
        const natural = control.dataset.naturalTabindex;
        if (natural === "") control.removeAttribute("tabindex");
        else control.setAttribute("tabindex", natural);
        delete control.dataset.naturalTabindex;
      }
    });
  });

  routeItems.forEach((item, index) => item.classList.toggle("is-active", index === activeIndex));
  progressBar?.style.setProperty("transform", `scaleY(${progress})`);
  if (percent) percent.textContent = String(Math.round(progress * 100)).padStart(3, "0");
  if (coordinate) coordinate.textContent = `SECTOR / ${(progress * 3019).toFixed(3).padStart(7, "0")}`;
  header?.classList.toggle("is-solid", progress > .035);
  sticky?.style.setProperty("--supply-drift", `${(progress - .71) * 260}px`);
  sticky?.style.setProperty("--route-step", String(clamp((progress - .575) / .17)));

  if (progress >= .405 && progress <= .61 && performance.now() > divisionLockedUntil) {
    const divisionProgress = clamp((progress - .422) / (.586 - .422));
    renderDivision(Math.min(5, Math.floor(divisionProgress * 6)));
  }
}

function closeMenu() {
  header?.classList.remove("is-open");
  menu?.setAttribute("aria-expanded", "false");
}
menu?.addEventListener("click", () => {
  const open = header.classList.toggle("is-open");
  menu.setAttribute("aria-expanded", String(open));
});
addEventListener("keydown", event => {
  if (event.key === "Escape" && header?.classList.contains("is-open")) {
    closeMenu();
    menu?.focus();
  }
});
addEventListener("pointerdown", event => {
  if (header?.classList.contains("is-open") && !header.contains(event.target)) closeMenu();
});

const targetById = new Map(actRanges.map(range => [range.element.id, range]));
document.querySelectorAll('a[href^="#"]').forEach(link => {
  const id = link.getAttribute("href").slice(1);
  const target = targetById.get(id);
  if (!target && id !== "entry") return;
  link.addEventListener("click", event => {
    event.preventDefault();
    closeMenu();
    if (id === "entry") scrollTo({top: 0, behavior: reduced ? "auto" : "smooth"});
    else {
      history.replaceState(null, "", `#${id}`);
      scrollToProgress(target.start + Math.min(.028, (target.end - target.start) * .25));
      setTimeout(() => target.element.focus({preventScroll: true}), reduced ? 0 : 650);
    }
  });
});
document.querySelectorAll("[data-skip-engine]").forEach(link => {
  link.addEventListener("click", event => {
    event.preventDefault();
    const target = targetById.get("origin");
    scrollToProgress(target.start + .02, "auto");
    history.replaceState(null, "", "#origin");
    target.element.focus({preventScroll: true});
  });
});

let engineVisible = true;
let engineFrame = 0;
const engineObserver = new IntersectionObserver(([entry]) => {
  engineVisible = entry.isIntersecting;
  if (engineVisible) lastEngineProgress = -1;
}, {rootMargin:"10% 0px"});
if (section) engineObserver.observe(section);
function monitorEngine() {
  if (engineVisible) update();
  engineFrame = requestAnimationFrame(monitorEngine);
}
addEventListener("resize", () => { lastEngineProgress = -1; }, {passive:true});

if (reduced) {
  prepareSupplyImages();
  acts.forEach(act => {
    act.removeAttribute("aria-hidden");
    act.classList.add("is-active");
  });
  world.setProgress(.9);
} else {
  update();
  engineFrame = requestAnimationFrame(monitorEngine);
}
